import { Fragment } from 'preact';
import { Text as T } from '@eo-locale/preact';
import { RatingDetails, RatingDetailsKeyToValue } from 'types/widget';

import { ProgressBar } from 'components/ProgressBar';
import { Text } from 'components/Text';

import styles from './StarsBreakdown.module.scss';

interface StarsBreakdownProps {
  /** Breakdown of reviews by rating */
  items: RatingDetails;
  /** Total number of reviews */
  totalReviews: number;
  /** Callback fired when filter button clicked */
  onClick: (filterKey: keyof RatingDetails) => void;
}

export function StarsBreakdown({ items, totalReviews }: StarsBreakdownProps) {
  const filtersMarkup = (Object.keys(items) as Array<keyof RatingDetails>).map(
    (key) => {
      const progressValue = (items[key].count / totalReviews) * 100;

      return (
        <Fragment key={key}>
          <Text size="small" variation="strong">
            <T
              id="stars_counting"
              defaultMessage={
                '{count, plural, one {{count} Star} other {{count} Stars}}'
              }
              count={String(RatingDetailsKeyToValue[key])}
            />
          </Text>
          <ProgressBar progress={progressValue} />
          <Text>{items[key].count.toString()}</Text>
        </Fragment>
      );
    },
  );

  return <div className={styles.StarsBreakdown}>{filtersMarkup}</div>;
}
